import { alpha, Box, Typography } from "@mui/material";
import { TotalInstallments } from "../AnaliseInstallments";

interface MetricCard {
  title: string;
  value: string;
  icon: React.ReactNode;
  backgroundColor: string;
  iconColor: string;
  textColor: string;
}

export const MetricsInstallments = ({ metrics, total }: { metrics: MetricCard[], total: number }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ mb: 1.5 }}>
        <Typography variant="h6" fontWeight="bold" color="text.secondary">Total de parcelas: {total}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: { xs: "wrap", md: "nowrap" },
          overflowX: { md: "auto" },
        }}
      >
        {metrics.map((metric, index) => (
          <Box
            key={index}
            sx={{
              backgroundColor: metric.backgroundColor,
              borderRadius: "12px",
              padding: "14px",
              minWidth: { xs: "100%", sm: "calc(50% - 8px)", md: "160px" },
              flex: { md: "1 1 0" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              boxShadow: "0 .1rem 1rem .25rem #A0A0A023",
              border: `1px solid ${alpha(metric.textColor, 0.4)}`,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "12px",
              }}
            >
              <Box
                component="span"
                sx={{ fontSize: 15, color: "text.secondary", fontWeight: 500, }}
              >
                {metric.title}
              </Box>
              <Box
                sx={{ display: "flex", alignItems: "center", justifyContent: "center", }}
              >
                <Box
                  sx={{
                    color: metric.iconColor,
                    display: "flex",
                    alignItems: "center",
                    "& svg": { fontSize: "22px", },
                  }}
                >
                  {metric.icon}
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box
                component="span"
                sx={{ fontSize: 20, fontWeight: "bold", color: metric.textColor, }}
              >
                {metric.value}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};